import { IWidgetConfigItem } from '@sitegen/common/types';

import { WIDGET_CONFIG, WIDGET_NAME } from '@sitegen/common/constants';

const WIDGET_ANALYTICS_INFO = {
    siteSection: '',
    siteName: '',
    homePage: {
        name: 'platform selection',
        subSection: 'flow'
    },
    loginPage: {
        name: 'login',
        subSection: 'flow'
    },
    successPage: {
        name: 'acquisition successful',
        subSection: 'flow'
    },
    endOperationPage: {
        name: 'free event is over',
        subSection: 'flow'
    },
    alreadyClaimedPage: {
        name: 'already claimed',
        subSection: 'error'
    },
    errorPage: {
        name: 'error occurred',
        subSection: 'error'
    },
    maintenancePage: {
        name: 'maintenance',
        subSection: 'maintenance'
    }
};

export class Analytics {
    public static Constants: typeof WIDGET_ANALYTICS_INFO = WIDGET_ANALYTICS_INFO;

    /** Add extra widget-specific values */
    public static configure(widget: WIDGET_NAME): void {
        const config: IWidgetConfigItem = WIDGET_CONFIG[widget];

        Analytics.Constants.siteSection = config.widgetFlowType;
        Analytics.Constants.siteName = config.widgetAnalytics;
    }
}
